import { render } from "./ShopManagement.vue?vue&type=template&id=76bbeff0"
import script from "./ShopManagement.vue?vue&type=script&lang=js"
export * from "./ShopManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__